import router from '@/router'
import store from '@/store'

const initialize = async () => {

  let settings = await store.dispatch('getSettings');

  document.title = settings.data.app.event_short + ' - Planner';
  store.commit('setSettings', settings.data);
  store.commit('setLanguage', settings.data.app.initial_language);

  store.state.schedule.sizes.horizontal.room = [
    { size: +settings.data.schedule.horizontal_room_xs, label: 'XS' },
    { size: +settings.data.schedule.horizontal_room_s, label: 'S' },
    { size: +settings.data.schedule.horizontal_room_m, label: 'M' },
    { size: +settings.data.schedule.horizontal_room_l, label: 'L' },
    { size: +settings.data.schedule.horizontal_room_xl, label: 'XL' },
  ];

  store.state.schedule.size.horizontal.room = settings.data.schedule.horizontal_room_default;
  store.state.schedule.size.horizontal.hour = settings.data.schedule.horizontal_hour_default;

  store.state.schedule.sizes.vertical.room = [
    { size: +settings.data.schedule.vertical_room_xs, label: 'XS' },
    { size: +settings.data.schedule.vertical_room_s, label: 'S' },
    { size: +settings.data.schedule.vertical_room_m, label: 'M' },
    { size: +settings.data.schedule.vertical_room_l, label: 'L' },
    { size: +settings.data.schedule.vertical_room_xl, label: 'XL' },
  ];

  store.state.schedule.size.vertical.room = settings.data.schedule.vertical_room_default;
  store.state.schedule.size.vertical.hour = settings.data.schedule.vertical_hour_default;

  let key = localStorage.getItem('x-api-key') || null;

  if (key && (
    !Object.keys(store.getters.authorized).length ||
    !Object.keys(store.getters.routes).length
  )) {

    const [wordings, authorized, routes, user] = await Promise.all([
      store.dispatch('getWordings'),
      store.dispatch('getAuthorized'),
      store.dispatch('getRoutes'),
      store.dispatch('getUser'),
    ]);

    store.commit('setProgress', false);
    store.commit('setWordings', wordings.data);
    store.commit('setAuthorized', authorized.data);
    store.commit('setRoutes', routes.data);
    store.commit('setUser', user.data);

    router.addRoute({
      path: '*',
      redirect: routes.data.start
    });

  } else {

    const wordings = await store.dispatch('getWordings');
    store.commit('setProgress', false);
    store.commit('setWordings', wordings.data);
  }
}

export default initialize